import React from "react";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

export default function DateTimePickerComponent({
  value,
  setValue,
  error,
  label,
  minDate = null,
  minTime = null,
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        error={error}
        label={label}
        value={value}
        onChange={(newValue) => setValue(newValue)}
        minDate={minDate}
        minTime={minTime}
      />
    </LocalizationProvider>
  );
}
